// PEPTEA — keeps the 3D vial label in sync with Shopify's variant picker.
// Only sets the viewer's public `strength` attribute (see peptea-vial README); the viewer
// repaints the label without rebuilding the vial. No design changes.
const roots = new WeakSet();

function init(root) {
  if (roots.has(root)) return;
  roots.add(root);
  const vial = root.querySelector('peptea-vial');
  const data = root.querySelector('script[data-peptea-vial-variants]');
  if (!vial || !data) return;
  let variants = {};
  try { variants = JSON.parse(data.textContent); } catch (e) { return; }
  const presetStrength = vial.dataset.presetStrength || '';
  const presetPoster = vial.dataset.presetPoster || '';
  const section = root.closest('.shopify-section') || document;

  const apply = (variantId) => {
    const v = variants[String(variantId)];
    if (!v || !v.strength) return;
    if (vial.getAttribute('strength') !== v.strength) vial.setAttribute('strength', v.strength);
    // Batch data of THIS variant only. Empty in Shopify = attribute removed = nothing printed
    // (no LOT/EXP row, no QR, no form line). Never carried over from another variant.
    [['lot', 'lot'], ['exp', 'exp'], ['coa-url', 'coa'], ['form', 'form']].forEach(([attr, key]) => {
      const val = (v[key] || '').trim();
      if (val) { if (vial.getAttribute(attr) !== val) vial.setAttribute(attr, val); }
      else if (vial.hasAttribute(attr)) vial.removeAttribute(attr);
    });
    // Poster (shown before the 3D is ready or when WebGL is unavailable) must match the label.
    const poster = vial.querySelector(':scope > img');
    if (poster) {
      const src = v.strength === presetStrength ? presetPoster : (v.image || presetPoster);
      if (src && poster.getAttribute('src') !== src) poster.setAttribute('src', src);
      poster.alt = poster.alt.replace(/\s\d+(?:[.,]\d+)?\s?(mg|MG|IU|ml|ML)$/, '') + ' ' + v.strength;
    }
  };

  // 1) Variant picker inputs (buttons or dropdown) carry data-variant-id.
  section.addEventListener('change', (event) => {
    const t = event.target;
    if (!(t instanceof Element) || t.closest('product-card') || !t.closest('variant-picker')) return;
    const opt = t instanceof HTMLSelectElement ? t.options[t.selectedIndex] : t;
    if (opt && opt.dataset && opt.dataset.variantId) apply(opt.dataset.variantId);
  });

  // 2) Safety net: the theme writes ?variant= to the URL on every change (and on back/forward).
  const fromUrl = () => {
    const id = new URL(window.location.href).searchParams.get('variant');
    if (id) apply(id);
  };
  section.addEventListener('shopify:product:select', () => setTimeout(fromUrl, 0));
  window.addEventListener('popstate', fromUrl);
}

function scan() { document.querySelectorAll('[data-peptea-vial-root]').forEach(init); }
scan();

// Quick add (opened from collection cards) clones the product page into a modal.
// There the 3D vial is removed before it can start; the static product image is shown instead (peptea.css).
const QUICK_ADD = '#quick-add-modal-content, quick-add-dialog';
const stripQuickAdd = (node) => {
  if (!(node instanceof Element)) return;
  const inModal = node.closest(QUICK_ADD);
  const vials = inModal ? (node.matches('peptea-vial') ? [node] : node.querySelectorAll('peptea-vial'))
                        : node.querySelectorAll(`:is(${QUICK_ADD}) peptea-vial`);
  vials.forEach((v) => v.remove());
};
new MutationObserver((records) => {
  for (const r of records) r.addedNodes.forEach(stripQuickAdd);
}).observe(document.documentElement, { childList: true, subtree: true });
// Theme editor section reloads insert fresh markup.
document.addEventListener('shopify:section:load', scan);
